import { Middleware } from 'redux';

// Converts uppercase event types to camelCase
// Ex: MY_EVENT -> myEvent
const typeToEvent = (type: string) =>
  type
    .split('_')
    .map(x => x.toLowerCase())
    .map((x, i) => (i === 0 ? x : x[0].toUpperCase() + x.slice(1)))
    .join('');

export type DataLayerEventData = {
  [key: string]: any;
};

export type DataLayerOptions = {
  eventNameAsKey?: boolean;
};

const defaultDataLayerOptions: DataLayerOptions = {
  eventNameAsKey: true,
};

export const pushEvent = (
  name: string,
  data: DataLayerEventData = {},
  optionsArg: DataLayerOptions = {}
) => {
  if (IS_SERVER || !window.dataLayer) {
    return;
  }

  const options: DataLayerOptions = {
    ...defaultDataLayerOptions,
    ...optionsArg,
  };

  const event = {
    event: name,
    ...(options.eventNameAsKey ? { [name]: data } : { ...data }),
  };
  window.dataLayer.push(event);
};

const middleware: Middleware = () => next => action => {
  next(action);

  if (!window.dataLayer) {
    return;
  }

  switch (action.type) {
    case 'ROUTE_LOADED':
      break;
    // NOTE: Any changes done to data or structure of PRODUCT_PRICE_CLICK needs to be
    // reflected in react/middlewares/out.js pre click
    case 'PRODUCT_PRICE_CLICK':
    default: {
      const { type, ...rest } = action;

      const name = typeToEvent(type);
      pushEvent(name, rest);
    }
  }
};

export default middleware;
